import { render, staticRenderFns } from "./appDetailView.vue?vue&type=template&id=a367a2c8&scoped=true"
import script from "./appDetailView.vue?vue&type=script&lang=js"
export * from "./appDetailView.vue?vue&type=script&lang=js"
import style0 from "./appDetailView.vue?vue&type=style&index=0&id=a367a2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a367a2c8",
  null
  
)

export default component.exports